const styles = `
    button.chat-toggle:hover {
      background-color: white !important;
      color: black !important;
      fill: black !important;
    }
    button.chat-toggle:hover svg path{
      transition-duration: 300ms;
    }
    button.chat-toggle:hover svg path{
      fill: black !important
    }
    button.chat-toggle {
      transition-duration: 300ms;
      overflow: hidden !important;
      box-sizing: border-box !important;
      border-radius: 0px !important;
      background-color: rgb(0, 0, 0) !important;
      min-height: 50px !important;
      height: 100% !important;
      padding: 8px !important;
      display: flex!important;
      justify-content: center!important;
      color: white !important;
      width: auto !important;
      min-width: 50px;
    }
    button.chat-toggle .chat-title {
      font-size: 16px !important;
      text-transform: uppercase !important;
    }
    button.chat-toggle .content {
      display: flex !important;
      gap: 1rem !important;
    }
    button.chat-toggle svg {
      height: 20px!important;
    }

    .chat-ui {
      flex-direction: column !important;
      border-radius: 0 !important;
      border: solid 1px #333333 !important;
      z-index: 100 !important;
      margin-bottom: -11px !important;
    }
    .chat-ui.chat-view {
      flex-direction: column !important;
      border-radius: 0 !important;
      border: solid 1px #333333 !important;
    }
    @media (min-width: 640px) {
      .chat-ui {
        flex-direction: column-reverse !important;
        margin-bottom: 0;
      }
      button.chat-toggle {
        //border-radius: 0px;
      }
    }

    .chat-app button.instant-answers-list__prompt {
      border: none !important;
      font-size: 16px !important;
      line-height: 22px !important;
      padding-top: .5rem !important;
      padding-bottom: .5rem !important;
      font-weight: 400 !important;
      background: black!important;
    }

    .interstitial-view__instant-answers-list {
      background: black !important;
      color: white !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .instant-answers {
      color: white !important;
      font-size: 24px !important;
      line-height: 24px !important;
      text-align: left !important;
      align-self: self-start !important;
      margin-left: 12px !important;
    }
      
    .composer-bar-wrapper {
      background: black !important;
      margin-bottom: 0 !important;
      margin-top: 0 !important;
    }
    .chat-ui.chat-view .composer-bar-wrapper {
      padding-bottom: 8px !important;
    }
    .composer-bar-wrapper .composer-bar-form {
      background: black !important;
    }
    .composer-bar__box {
      background: black !important;
    }
    .composer-bar__message-text {
      background: black !important;
    }

    .interstitial-view__welcome {
      background: black !important;
    }
    .interstitial-view__welcome .return-to-chat-wrapper {
      margin: 0px 12px 10px 12px !important;
    }
      
    .store-info {
      padding: 0 24px 10px 24px !important;
      background: black !important;
      color: white !important;
    }
    .store-info h2 {
      font-size: 24px !important;
      line-height: 24px !important;
    }

    .chat-header {
      border-top-right-radius: 0 !important;
      border-top-left-radius: 0 !important;
    }
    .chat-messages__list {
      background: black !important;
    }
    .message-bubble-outgoing {
      background-color: #1f1f1f !important;
    }
  `;

  const overrideChatStyling = async (delay) => {
      const uiHost = document.querySelector("#ShopifyChat");
      if (!uiHost?.shadowRoot) return;
      
      // Add searchable element to DOM once override started
      const checkTargetEl = document.createElement('div');
      checkTargetEl.classList.add("override-check-target");
      uiHost.shadowRoot.appendChild(checkTargetEl);

      // Inject custom styling into frame
      const styleEl = document.createElement('style');
      styleEl.innerHTML = styles;
      uiHost.shadowRoot.appendChild(styleEl);

      // Button needs to re-apply styling as opening/closing clears it
      // uiHost.shadowRoot.querySelector('.chat-toggle')?.addEventListener('click', () => {
      //   setTimeout(() => {
      //     overrideChatStyling(250);
      //   }, delay ?? 1000);
      // });
      // uiHost.shadowRoot.querySelector('.chat-app--close-button')?.addEventListener('click', () => {
      //   setTimeout(() => {
      //     overrideChatStyling(250);
      //   }, 500);
      // });
      uiHost.addEventListener('click', setTimeout(overrideChatStyling(250), 500))

      // Add listener to any other buttons
      const returnButton = uiHost.shadowRoot.querySelector('.return-to-chat-wrapper'); // Return to chat button
      if (returnButton) returnButton.addEventListener('click', () => { overrideChatStyling(250) });

      const backButton = uiHost.shadowRoot.querySelector('.chat-header__info')?.firstElementChild; // Back button when chat open
      if (backButton) backButton.addEventListener('click', () => { overrideChatStyling(250) });

      uiHost.shadowRoot.querySelectorAll('.instant-answers-list__prompt').forEach(button => {
        button.addEventListener('click', overrideChatStyling);
      });


      // Change chat togggle button content
      const toggle = uiHost.shadowRoot.querySelector('.chat-toggle');
      if (toggle) {
        toggle.innerHTML = `
          <span class="content">
            CHAT
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.5379 2.05208e-08C5.40447 -9.00304e-05 4.29072 0.296197 3.30716 0.859462C2.3236 1.42273 1.50442 2.23339 0.930907 3.21101C0.357395 4.18863 0.0494844 5.29922 0.0377295 6.43259C0.0259747 7.56595 0.310784 8.6827 0.863896 9.672L0.0678964 11.754C0.00172536 11.9271 -0.0150599 12.1151 0.0194135 12.2972C0.0538869 12.4792 0.138263 12.6481 0.263129 12.785C0.387994 12.9219 0.548439 13.0214 0.726563 13.0725C0.904687 13.1235 1.09349 13.124 1.2719 13.074L3.7589 12.377C4.63985 12.7932 5.6031 13.0061 6.57742 12.9999C7.55174 12.9936 8.51218 12.7684 9.38772 12.3409C10.2633 11.9134 11.0315 11.2945 11.6356 10.5301C12.2397 9.76561 12.6642 8.87513 12.8777 7.92448C13.0913 6.97382 13.0883 5.98733 12.8692 5.03796C12.65 4.08859 12.2202 3.20064 11.6116 2.43977C11.003 1.67891 10.2311 1.0646 9.35306 0.642292C8.475 0.219983 7.51223 0.000473115 6.5379 2.05208e-08ZM1.0389 6.5C1.03934 5.30143 1.4313 4.13581 2.15514 3.18049C2.87898 2.22518 3.89507 1.53246 5.04881 1.20774C6.20256 0.883016 7.4308 0.944066 8.54665 1.3816C9.66251 1.81913 10.6049 2.6092 11.2304 3.63159C11.856 4.65398 12.1304 5.85272 12.012 7.04543C11.8936 8.23813 11.3888 9.35951 10.5744 10.2389C9.76008 11.1184 8.68074 11.7077 7.50064 11.9173C6.32053 12.1269 5.10427 11.9452 4.0369 11.4L3.8629 11.31L1.0029 12.111L1.9719 9.575L1.8439 9.365C1.31559 8.50285 1.0376 7.51114 1.0389 6.5ZM9.5009 16C8.56528 16.0007 7.64057 15.7991 6.79015 15.409C5.93973 15.0189 5.18371 14.4496 4.5739 13.74C5.14829 13.8952 5.73911 13.9814 6.3339 13.997C7.26066 14.6496 8.36642 14.9999 9.4999 15C10.4019 15 11.2519 14.783 12.0019 14.4L12.1759 14.31L15.0359 15.111L14.0669 12.575L14.1949 12.365C14.7049 11.531 14.9999 10.551 14.9999 9.5C15.0017 8.38951 14.6655 7.30478 14.0359 6.39C14.0278 5.79509 13.9489 5.20327 13.8009 4.627C14.493 5.23607 15.0471 5.98582 15.4264 6.82615C15.8056 7.66649 16.0011 8.57807 15.9999 9.5C15.9999 10.651 15.6999 11.733 15.1749 12.672L15.9699 14.754C16.0361 14.9271 16.0529 15.1151 16.0184 15.2972C15.9839 15.4792 15.8995 15.6481 15.7747 15.785C15.6498 15.9219 15.4894 16.0214 15.3112 16.0725C15.1331 16.1235 14.9443 16.124 14.7659 16.074L12.2789 15.377C11.4359 15.777 10.4929 16 9.4989 16" fill="white"/>
            </svg>
          </span>
        `;
      }

      // Change quick answers heading
      const heading = uiHost.shadowRoot.querySelector('.instant-answers');
      if (heading) heading.innerHTML = "FAQs";

      // Move info text to top of popup
      const oldInfo = uiHost.shadowRoot.querySelector('.store-info');
      if (!oldInfo) return;

      const info = document.createElement('div');
      uiHost.shadowRoot.querySelector('.chat-ui')?.append(info);
      info.classList.add('store-info');
      info.innerHTML = oldInfo.innerHTML;
      oldInfo.innerHTML = "";
  };

  // Attempts to overrride styling once per second until done
  const awaitOverrideChatStyling = async (delay) => {
    setTimeout(() => {
      console.log('Checking if chat styling applied...');

      const uiHost = document.querySelector("#ShopifyChat");
      const checkTarget = uiHost.shadowRoot?.querySelector('.override-check-target') ?? null;

      if(!checkTarget) return awaitOverrideChatStyling(1000);

      console.log('Chat styling applied!');
      
      // Continue to check once every 5 seconds
      awaitOverrideChatStyling(10000);
    }, delay);
  }

  window.addEventListener('DOMContentLoaded', async () => {
    overrideChatStyling();
    setTimeout(() => {
      overrideChatStyling(0);
      awaitOverrideChatStyling(1000);
    }, 1500)
  });